// extracted by mini-css-extract-plugin
export default {"container":"lN-z","dimension":"mN-z","dimensionLabels":"nN-z"};